export default __webpack_public_path__ + "static/media/Marique's Goldscale Cache.5ba05329.jpg";